import React from "react";
import { context } from './AppContext';
import { Button, Container, Row, Col, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import Locale from "../locale/Locale";

export default class TopBar extends React.Component {
    state = {
        apiVer: ""
    }

    componentDidMount() {
    }

    async promptImpersonate(emailAddr) {
        let email = prompt(Locale.gettext("Enter email"), emailAddr);
        if (email?.length > 0) {
            let result = await context.impersonate(email);
            if (result) {
                document.location.reload();
            } else {
                alert("Error switching please check email address");
                this.promptImpersonate(email);
            }
        }
    }

    render() { 
        let currentRealm = context.realms[window.localStorage.realm];
        //console.log(context.userInfo);
        let menus = [
            ( <Nav.Item key="sites"><Nav.Link key="sites_link" href="#/sites">{ Locale.gettext("Sites") }</Nav.Link></Nav.Item> ),
            ( <Nav.Item key="alerts"><Nav.Link key="alerts_link"  href="#/alerts">{ Locale.gettext("Alerts") }</Nav.Link></Nav.Item> ),
            ( <Nav.Item key="attendant_sizing_tool"><Nav.Link key="attendant_sizing_tool" href="#/attendant_sizing_tool">{ Locale.gettext("Matchmaker") }</Nav.Link></Nav.Item> )
        ];
        if (context.userInfo?.organizations.length === 0) {
            menus = [];
        }
        //console.log(context.userInfo.organizations[0].imageData);
        //console.log("ASDOHAOHISD", (context.userInfo?.admin || !!window.localStorage.accessTokenSwitch));

        // disabled until we can get the rest of the site styled the way we want
        //let logoUrl = context.userInfo?.organizations[0]?.imageData?.logo?.uri || "https://poolside-assets-public.s3.amazonaws.com/organizations/poolside/Poolside-Logo-faded.png";
        let logoUrl = "https://poolside-assets-public.s3.amazonaws.com/organizations/poolside/Poolside-Logo-Text-Inverse.png";

        return (
            <Navbar bg="dark" variant="dark" expand="md" className="px-3 py-2">
                <Container fluid>

                    <Navbar.Brand href="#/sites" className="d-flex align-items-center">
                        <img
                            alt="logo"
                            src={logoUrl}
                            height={35}
                            style={{ marginRight: 10 }}
                        />
                    </Navbar.Brand>

                    
                    <Navbar.Toggle aria-controls="main-navbar" className="mainmenutoggle" onClick={ () => this.setState(prev => ({ expanded: !prev.expanded })) }/>
                    <Navbar.Collapse id="main-navbar" className="mainmenu">
                        <Nav>
                            {menus}
                            <Nav.Item>
                                <NavDropdown
                                    id="user-nav-dropdown"
                                    title={
                                        context.userInfo
                                            ? context.userInfo.firstName + " " + context.userInfo.lastName
                                            : Locale.gettext("Loading")
                                    }
                                    className="user-nav-dropdown"
                                    menuVariant="dark" 
                                >
                                    <NavDropdown.Item>
                                        <Navbar.Text style={{ padding: 10 }}>
                                            {context.userInfo ? (
                                            <div>
                                                {context.userInfo.email}<br />
                                                {context.userInfo.organizations[0]?.name}
                                            </div>
                                            ) : Locale.gettext("Loading")}
                                        </Navbar.Text>
                                        <div style={{ padding: 10 }}>
                                            {(context.userInfo?.admin || !!window.localStorage.accessTokenSwitch || ["Local", "Dev"].includes(window.localStorage.realm)) && (
                                            <ToggleButtonGroup
                                                type="radio"
                                                className="mb-2"
                                                name="realm"
                                                value={context.realms[window.localStorage.realm]?.name}
                                            >
                                                {Object.values(context.realms).map((realm) => (
                                                <ToggleButton
                                                    key={"realm_" + realm.name}
                                                    value={realm.name}
                                                    checked={context.realms[window.localStorage.realm]?.name === realm.name}
                                                    style={{ fontSize: 16, padding: 5 }}
                                                    onClick={() => {
                                                    window.localStorage.realm = realm.name;
                                                    document.location.reload();
                                                    }}
                                                >
                                                    {realm.name}
                                                </ToggleButton>
                                                ))}
                                            </ToggleButtonGroup>
                                            )}
                                            {(context.userInfo?.admin || !!window.localStorage.accessTokenSwitch) && (
                                            !!window.localStorage.accessTokenSwitch ? (
                                                <div><Button onClick={() => {
                                                context.unpersonate();
                                                document.location.reload();
                                                }}>{Locale.gettext("UnSwitch")}</Button></div>
                                            ) : (
                                                <div><Button onClick={async () => {
                                                this.promptImpersonate();
                                                }}>{Locale.gettext("Switch User")}</Button></div>
                                            )
                                            )}
                                        </div>
                                    </NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item onClick={() => context.logout()}>
                                        {Locale.gettext("Log Out")}
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </Nav.Item>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        );
    }
}